import { Typography } from "@mui/material";
import { Box } from "@mui/system";

type Props = {
  title: string;
  currentStep: number;
  step: number;
};

const Step: React.FC<Props> = ({ title, currentStep, step }: Props) => {
  return (
    <Box>
      <Typography
        color={currentStep >= step ? "text.primary" : "text.hint"}
        variant="body1"
        gutterBottom
      >
        {step}. {title}
      </Typography>
      <Box
        sx={{
          height: "5px",
          borderRadius: "10px",
          backgroundColor: currentStep >= step ? "#fda36f" : "#e1e1e1",
          width: "100%",
        }}
      ></Box>
    </Box>
  );
};

export default Step;
